export const HOST_URL = "http://dev.ksic.net";
// export const HOST_URL = 'http://localhost';
// export const HOST_URL = "http://30.30.30.11";
